import Login from "../components/Login/Login"

const LoginContainer = () => {
    return <Login/>
}

export default LoginContainer